// extracted by mini-css-extract-plugin
module.exports = {"contact":"ContactPerson_contact__7uUyH"};